/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PermissionGrantUserResponse } from './permission-grant-user-response';
import { DateTimePeriod } from './date-time-period';


export interface PermissionGrantResponse { 
    id?: string;
    sourceUser?: PermissionGrantUserResponse;
    destinationUser?: PermissionGrantUserResponse;
    grantDates?: DateTimePeriod;
    permissionIds?: Array<string> | null;
    reason?: string | null;
}

